<template>
    <div class="cargo-card">
        <div class="cargo-card__header">
            <div>
                <div class="cargo-card__title">Cargos y sedes asignados</div>
                <div class="cargo-card__hint">{{ resumenAsignados }}</div>
            </div>
        </div>

        <div class="cargo-card__chips" v-if="asignados.length">
            <button
                v-for="(asignado, index) in asignados"
                :key="asignado.idsede + '-' + asignado.idcargo"
                type="button"
                class="cargo-chip"
                :disabled="quitando"
                @click.stop="onRemove(asignado)"
                :title="'Quitar ' + asignado.nombre"
            >
                <span class="cargo-chip__remove">x</span>
                <span class="cargo-chip__number">{{ index + 1 }}.</span>
                <span>{{ asignado.nombre }}</span>
            </button>
        </div>
        <div v-else class="cargo-empty">Sin cargos asignados.</div>

        <div class="cargo-card__actions mt-8">
            <button type="button" class="cargo-card__toggle" @click="expandido = !expandido">
                {{ expandido ? 'Ocultar gestion' : 'Gestionar cargos' }}
            </button>
        </div>

        <div v-show="expandido" class="cargo-card__body">
            <div class="cargo-form">
                <multiselect class="cargo-select" v-model="modelo.idsede" :options="sedes" track-by="id" label="nombre" :searchable="true" :close-on-select="true" :show-labels="false" :disabled="asignando" placeholder="Buscar o seleccionar sede..."></multiselect>
                <multiselect class="cargo-select" v-model="modelo.idcargo" :options="cargos" track-by="id" label="nombre" :searchable="false" :close-on-select="true" :show-labels="false" :disabled="asignando" placeholder="Seleccione el cargo..."></multiselect>
                <button @click="asignar" type="button" class="cargo-assign" :disabled="asignando">
                    <span v-if="asignando" class="cargo-spinner"></span>
                    {{ asignando ? 'Asignando...' : 'Asignar' }}
                </button>
            </div>
            <div class="cargo-help">El usuario debe estar activo para modificar cargos o sedes.</div>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError,exito2,error2} from '@/components/Utils.js'
export default {
    props:{ model:Array,default:{type:Array,required:false,default:null},toasig:{type:Object,required:false} },
    data(){
        return{
            asignando: false,
            quitando: false,
            sedes: [],
            cargos: [],
            asignados: [],
            expandido: false,
            asig: {},
            modelo: {
                idsede: null,
                idcargo: null,
            } 
        }
    },
    computed:{
        resumenAsignados(){
            const total = this.asignados.length;
            if( total === 0 ) return 'No hay cargos registrados para este usuario';
            if( total === 1 ) return '1 cargo registrado';
            return total + ' cargos registrados';
        },
    },
    watch:{
        'default': function(a){
            if( a == null ) return;
            this.cargar();
            this.modelo.idsede = null;
            this.modelo.idcargo = null;
        },
    },
    methods:{
        async getSedes() {
            let rolid = this.$store.state.CARGO.id;
            if(rolid != 1){
                let d = this.$store.state.CARGOS;
                const sedes = [];
                d.forEach(x=>{
                    sedes.push({id:x.sede.id, nombre:x.sede.nombre,unidad_negocio:x.sede.unidad_negocio})
                })
                this.sedes = sedes;
                return;
            }

            var vue = this;
            var sql = gql`query{getSedes{id,nombre,unidad_negocio}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var dat = data.data.getSedes;
                var jerarquia = this.$store.state.CARGO.id;
                if( jerarquia != 1 ){
                    var thiz = this;
                    dat = dat.filter( function(e){
                        var permitido = thiz.$store.state.CARGOS.find( x => x.idsede == e.id ); // mostrar solo las sedes permitidas
                        return permitido != null;
                    });
                }
                
                vue.sedes = dat;
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getSedes' ) )
            })
        },
        async getCargos() {
            var vue = this;
            var sql = gql`query{getCargos{id,nombre}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var dat = data.data.getCargos;
                var jerarquia = this.$store.state.CARGO.id;
                var mkt = jerarquia == 11 || jerarquia == 11 || jerarquia == 11 ;
                // window.console.log( dat )
                if( jerarquia != 1 ){
                    dat = dat.filter(function(e){ 
                        if( mkt ){
                            return (e.nombre!="Master" && (e.id >= jerarquia && e.id <=13)) 
                        }else{
                            return (e.nombre!="Master")    
                        }
                    })
                }
                if(jerarquia != 1 ){
                    dat = dat.filter(function(e){return e.id != 14 })
                }
                
                vue.cargos = dat;
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getCargos' ) )
            })
        },
        onRemove( removedOption ){
            if( this.asignados.length <= 1 ){
                this.$notify( error2( 'No Valido','El usuario debe conservar al menos un cargo asignado.',4000 ) )
                return;
            }
            var xu = sessionStorage.xxusuario;
            if( xu == null ) return;
            var iduser = JSON.parse(xu).id;
            var input = {};
            input.idusuario = iduser;
            input.idcargo = removedOption.idcargo;
            input.idsede = removedOption.idsede;
            input.desde = removedOption.desde;
            this.deleteCargo( input, removedOption );
        },
        cargar(){
            this.asignados = [];
            const agregados = new Set();

            if( this.default ){
                this.default.forEach(x=>{
                    if( !x.idsede || !x.idcargo ) return;
                    const key = x.idsede.id + '-' + x.idcargo.id;
                    if( agregados.has(key) ) return;
                    const nom = x.idsede.nombre + ' - '+x.idcargo.nombre;
                    this.asignados.push( {idcargo:x.idcargo.id,idsede:x.idsede.id,nombre:nom,desde:x.desde} );
                    agregados.add(key);
                })
            }

            if( this.modelo.idsede != null && this.modelo.idcargo != null ){
                var existe = this.asignados.find(x => (x.idsede==this.modelo.idsede.id && x.idcargo==this.modelo.idcargo.id) );
                if( !existe ) {
                    var nom = this.modelo.idsede.nombre + ' - '+this.modelo.idcargo.nombre;
                    this.asignados.push( {idcargo:this.modelo.idcargo.id,idsede:this.modelo.idsede.id,nombre:nom,desde:this.modelo.desde} );
                }
            }
        },
        asignar(){
            if( this.modelo.idsede != null && this.modelo.idcargo != null ){
                //var existe = this.asignados.find(x => (x.idsede==this.modelo.idsede.id && x.idcargo==this.modelo.idcargo.id) );
                var existe = this.asignados.find(x => (x.idsede==this.modelo.idsede.id ) ); // no mas de un cargo por sede
                if( !existe ) {
                    this.asignando = true;
                    window.console.log( "ASIGNARRR ",this.modelo );
                    this.agregarCargo( this.modelo );
                }else{
                    this.$notify( error2( 'No Valido','No se permite mas de un cargo por sede.',4000 ) )
                }
            }else{
                this.$notify( error2( 'Seleccione','Falta sede y cargo',2000 ) )
            }
        },
        async deleteCargo( input, removedOption ){
            var vue = this;
            if( vue.asignados.length <= 1 ){
                vue.$notify( error2( 'No Valido','El usuario debe conservar al menos un cargo asignado.',4000 ) )
                return;
            }
            vue.quitando = true;
            var sql = gql`mutation{ deshabilitarCargoUsuarioSede(input:${window.stringifyObject(input)}){ok,errors{message}} }`;
            window.console.log( "DESHABILITANDO::::",sql,input ); 
            await this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                var ok = data.data.deshabilitarCargoUsuarioSede.ok;
                if( ok ) {
                    vue.asignados = vue.asignados.filter(x => !(x.idcargo == removedOption.idcargo && x.idsede == removedOption.idsede));
                    vue.$notify( exito2( 'Eliminado','Cargo eliminado.',2000 ) )
                }else{
                    var errores = JSON.stringify(data.data.deshabilitarCargoUsuarioSede.errors);
                    vue.$notify( error2( 'No Valido','Del Servidor: '+errores,4000 ) )
                }
                vue.quitando = false;

            }).catch((error) => {
                window.console.error(error)
                vue.$notify( parseJsonError( error,'deshabilitarCargoUsuarioSede' ) )
                vue.quitando = false;
            })
        },
        async agregarCargo( modelo ){
            var vue = this;
            var xu = sessionStorage.xxusuario; 
            if( xu == null ) {
                this.asignando = false;
                return;
            }
            var iduser = JSON.parse(xu).id;
            var input = {};
            input.idusuario = iduser;
            input.cargos = [ { idcargo:modelo.idcargo.id ,idsede:modelo.idsede.id } ];
            if( this.toasig ){
                window.sessionStorage.setItem( 'CARGOS_ASIG',JSON.stringify(input.cargos) )
                this.toasig.asignados = input.cargos;
            }

            var sql = gql`mutation{ registrarCargoUsuarioSede(input:${window.stringifyObject(input)}){ok,errors{message}} }`;
            window.console.log( "AGRREGANDO:::: ",sql,input ); 
            await this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                var ok = data.data.registrarCargoUsuarioSede.ok;
                window.console.log( "DATA ",data )
                if( ok ) {
                    vue.$notify( exito2( 'Registrado','Cargo Registrado.',2000 ) )
                    var nom = modelo.idsede.nombre + ' - '+modelo.idcargo.nombre;
                    this.asignados.push( {idcargo:modelo.idcargo.id,idsede:modelo.idsede.id,nombre:nom,desde:modelo.desde} );
                }else{
                    var errores = JSON.stringify(data.data.registrarCargoUsuarioSede.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    this.$notify( error2( 'No Valido','Del Servidor: '+vals,4000 ) )
                }
                this.asignando = false;

            }).catch((error) => {
                window.console.error(error)
                vue.$notify( parseJsonError( error,'registrarCargoUsuarioSede' ) )
                vue.asignando = false;
            })
        }
    },
    mounted(){
        this.getSedes();
        this.getCargos();
    }
}
</script>

<style scoped>
.cargo-card {
    border: 1px solid #dfe6f2;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 12px;
    overflow: visible;
    position: relative;
    z-index: 2;
}

.cargo-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border-bottom: 1px solid #edf1f7;
}

.cargo-card__title {
    color: #283593;
    font-size: 0.9rem;
    font-weight: 700;
}

.cargo-card__hint,
.cargo-help,
.cargo-empty {
    color: #667085;
    font-size: 0.78rem;
}

.cargo-card__toggle,
.cargo-assign {
    border: 0;
    border-radius: 6px;
    font-size: 0.78rem;
    font-weight: 700;
    padding: 7px 12px;
    white-space: nowrap;
}

.cargo-card__toggle {
    background: #eef2ff;
    color: #283593;
}

.cargo-card__chips {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 14px;
    max-height: 260px;
    overflow-y: auto;
}

.cargo-chip {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    max-width: 100%;
    gap: 8px;
    border: 1px solid #cdd7ea;
    border-radius: 999px;
    background: #f8fafc;
    color: #344054;
    font-size: 0.78rem;
    line-height: 1.2;
    padding: 6px 9px 6px 11px;
}

.cargo-chip span:last-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cargo-chip__remove {
    color: #9b1c1c;
    font-weight: 700;
}

.cargo-chip__number {
    color: #667085;
    font-weight: 700;
    min-width: 20px;
}

.cargo-empty {
    padding: 10px 14px;
}

.cargo-card__actions {
    display: flex;
    justify-content: flex-start;
    padding: 0 14px 12px;
}

.cargo-card__body {
    padding: 12px 14px 14px;
    border-top: 1px solid #edf1f7;
    background: #fbfcfe;
    overflow: visible;
    position: relative;
    z-index: 5;
}

.cargo-form {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(180px, 1fr) auto;
    gap: 10px;
    align-items: start;
}

.cargo-select {
    min-width: 0;
}

.cargo-select >>> .multiselect__tags {
    min-height: 38px;
    border: 1px solid #b8c4d6;
    border-radius: 6px;
    background: #fff;
    box-shadow: inset 0 1px 2px rgba(16,24,40,0.04);
}

.cargo-select >>> .multiselect__placeholder,
.cargo-select >>> .multiselect__single,
.cargo-select >>> .multiselect__input {
    color: #344054;
    font-size: 0.84rem;
}

.cargo-select >>> .multiselect__placeholder {
    color: #8a94a6;
}

.cargo-select.multiselect--active >>> .multiselect__tags {
    border-color: #283593;
    box-shadow: 0 0 0 2px rgba(40,53,147,0.12);
}

.cargo-select.multiselect--active {
    z-index: 1000;
}

.cargo-select >>> .multiselect__content-wrapper {
    z-index: 1000;
    max-height: 260px !important;
    box-shadow: 0 10px 24px rgba(16,24,40,0.18);
}

.cargo-assign {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    background: #283593;
    color: #fff;
    min-height: 38px;
}

.cargo-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255,255,255,0.45);
    border-top-color: #fff;
    border-radius: 50%;
    animation: cargo-spin 0.75s linear infinite;
}

@keyframes cargo-spin {
    to {
        transform: rotate(360deg);
    }
}

.cargo-assign:disabled,
.cargo-chip:disabled {
    cursor: wait;
    opacity: 0.65;
}

.cargo-help {
    margin-top: 8px;
}

@media (max-width: 760px) {
    .cargo-card__header {
        align-items: flex-start;
    }

    .cargo-form {
        grid-template-columns: 1fr;
    }

    .cargo-assign {
        width: 100%;
    }
}
</style>
